import {
    Folder,
    MoreVertical
} from "lucide-react";

export default function MediaSidebarItem({

    list,
    active,
    onClick,
    onMenu

}) {

    return (

        <div

            className={`sidebar-item ${
                active ? "active" : ""
            }`}

            onClick={onClick}

        >

            <div className="sidebar-left">

                <div className="sidebar-icon">

                    <Folder size={17} />

                </div>

                <div className="sidebar-text">

                    <div className="sidebar-name">

                        {list.name}

                    </div>

                    <div className="sidebar-files">

                        {list.totalFiles || 0} files

                    </div>

                </div>

            </div>

            <button

                className="sidebar-menu"

                onClick={e => {

                    e.stopPropagation();

                    onMenu({

                        list,

                        anchor: {

                            x: e.clientX,
                            y: e.clientY

                        }

                    });

                }}

            >

                <MoreVertical size={17} />

            </button>

            <style>{`

.sidebar-item{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin:4px 12px;

    padding:10px 12px;

    border-radius:12px;

    cursor:pointer;

    transition:all .18s ease;

}

.sidebar-item:hover{

    background:#F8FAFC;

}

.sidebar-item.active{

    background:#E8F1FF;

}

.sidebar-left{

    display:flex;

    align-items:center;

    gap:12px;

    flex:1;

    min-width:0;

}

.sidebar-icon{

    width:36px;

    height:36px;

    border-radius:10px;

    background:#EFF6FF;

    display:flex;

    align-items:center;

    justify-content:center;

    color:rgba(144, 202, 249,1);

    flex-shrink:0;

}

.sidebar-item.active .sidebar-icon{

    background:rgba(144, 202, 249,1);

    color:#FFF;

}

.sidebar-text{

    flex:1;

    min-width:0;

}

.sidebar-name{

    font-size:14px;

    font-weight:600;

    color:#0F172A;

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

}

.sidebar-files{

    margin-top:2px;

    font-size:12px;

    color:#64748B;

}

.sidebar-menu{

    width:34px;

    height:34px;

    border:none;

    border-radius:8px;

    background:transparent;

    display:flex;

    align-items:center;

    justify-content:center;

    cursor:pointer;

    color:#64748B;

    opacity:0;

    transition:.18s;

}

.sidebar-item:hover .sidebar-menu{

    opacity:1;

}

.sidebar-menu:hover{

    background:#E2E8F0;

    color:rgba(144, 202, 249,1);

}

`}</style>

        </div>

    );

}